class SystemSetup
  constructor: ->
    @dom =
      base:           '.setup'
      contactForm:    '.contact-form'
      logTypeLink:    'a[data-change-log-type]'
      logTypeSelect:  'select[name=log_type]'
      logsIndicator:  '.logs-received-indicator'
      platformLink:   'a[data-change-log-platform]'
      platformSelect: 'select[name=log_platform]'
      searchInput:    '#filter_loggers'

    $(@dom.contactForm).on 'submit', @onContactFormSubmit

    if !document.querySelector('.setup[data-heroku-addon]')
      @nonHerokuSetup()

  ## Methods

  nonHerokuSetup: ->
    @logStatusUrl = document.querySelector(@dom.base).getAttribute('data-log-status-url')

    $(window).on 'popstate', @onPopstate
    $(window).on 'hashchange', @onHashChange
    $(@dom.logTypeLink).on 'click', @onLogTypeClick
    $(@dom.logTypeSelect).on 'change', @onLogTypeChange
    $(@dom.platformLink).on 'click', @onPlatformClick
    $(@dom.platformSelect).on 'change', @onPlatformChange
    $(@dom.searchInput).on 'keydown', _.debounce(@onSearchKeydown, 1000)
    $(@dom.searchInput).liveFilter '.grid--loggers', 'is-hidden', @onLiveFilter

    # set initial query state, so back/forward works correctly
    @setInitialQueryState()

    # start polling for logs received
    @pollForLogsId = setInterval(@pollForLogs, 10000)

  disableLogTypeSelect: (shouldDisable) ->
    document.querySelector(@dom.logTypeSelect).disabled = shouldDisable

  # poll logs received, for logs received indicator
  pollForLogs: =>
    return if document.hidden

    $.ajax
      type: 'GET'
      dataType: 'json'
      url: @logStatusUrl
      error: =>
        clearInterval(@pollForLogsId)
      success: (json) =>
        return unless json.logs_received

        $indicator = $(@dom.logsIndicator)
        $indicator.filter(':visible').addClass('mod-success')
        $indicator.filter(':hidden').addClass('mod-success-alt')

        if json.sources.length
          sources = json.sources.map((source) ->
            "<a href='#{source.events_path}'>#{source.name}</a>"
          )
          sources = sources.join(', ')

          $indicator.filter(':visible').find('.sources').html(sources)

        clearInterval(@pollForLogsId)

  setInitialQueryState: ->
    fragment = window.location.hash.substr(1)
    state =
      type: document.querySelector(@dom.logTypeSelect).value
      platform: document.querySelector(@dom.platformSelect).value

    PT.Utils.QueryObject.add(state, true)
    window.location.hash = fragment

  triggerPlatformOrTypeChange: (target, value) ->
    if target == 'type'
      selector = @dom.logTypeSelect
    else
      selector = @dom.platformSelect

    el = document.querySelector(selector)
    el.value = value
    $(el).trigger('change')

  triggerLogTypeChange: (type) ->
    return unless type
    @triggerPlatformOrTypeChange('type', type)

  triggerPlatformChange: (platform) ->
    return unless platform
    @triggerPlatformOrTypeChange('platform', platform)


  updatePlatformOrType: (target, value) ->
    document.querySelector(@dom.base).setAttribute("data-selected-log-#{target}", value)

    if PT.Utils.QueryObject.get(target) != value
      PT.Utils.QueryObject.add("#{target}": value)

  updateLogType: (type) ->
    return unless type
    @updatePlatformOrType('type', type)

  updatePlatform: (platform) ->
    return unless platform
    @updatePlatformOrType('platform', platform)

    # special case for "other" platform
    # fix issue where "autofocus" works the first time, but not subsequent times
    if platform == 'other'
      document.querySelector('[data-log-platform=other] input[autofocus]').focus()


  ## Event Handlers

  onContactFormSubmit: (e) ->
    e.preventDefault()

    form = e.target

    $.ajax
      type: 'POST'
      data: $(form).serialize()
      dataType: 'json'
      url: form.action
      error: ->
        form.querySelector('button[type=submit]').disabled = false
      success: (json) ->
        form.querySelector('.notice').innerHTML = json.notice
        form.querySelector('.success').classList.remove('is-hidden')
        form.querySelector('.fields').classList.add('is-hidden')

  onHashChange: (e) =>
    e.preventDefault()
    section = window.location.hash.substr(1)
    first = '.js-fragment:first-of-type'
    target = first

    if section
      target = document.getElementById(section) || first

    $('.js-fragment').hide()
    $(target).show()

  onLiveFilter: ->
    _(document.querySelectorAll('.grid--loggers')).forEach (el) ->
      if el.querySelectorAll('li:not(.is-hidden)').length
        el.classList.remove('is-empty')
      else
        el.classList.add('is-empty')

  onLogTypeChange: (e) =>
    @updateLogType(e.target.value)

  onLogTypeClick: (e) =>
    e.preventDefault()

    @triggerLogTypeChange(e.target.getAttribute('data-change-log-type'))
    window.scroll(0, 0)

  onPlatformChange: (e) =>
    @updatePlatform(e.target.value)
    @disableLogTypeSelect(e.target.querySelector("option[value=#{e.target.value}]").hasAttribute('data-no-type'))

  onPlatformClick: (e) =>
    e.preventDefault()

    @triggerPlatformChange(e.target.getAttribute('data-change-log-platform'))
    window.scroll(0, 0)

  onPopstate: (e) =>
    return unless e.originalEvent.state

    @triggerLogTypeChange(e.originalEvent.state.type)
    @triggerPlatformChange(e.originalEvent.state.platform)

  onSearchKeydown: (e) =>
    value = e.currentTarget.value

    if value and value != @lastSearchValue
      @lastSearchValue = value

      if typeof ga == 'function'
        ga 'send', 'event',
          eventCategory: 'New system setup'
          eventAction: 'search'
          eventLabel: value

$ ->
  new SystemSetup()
